import { memo, useMemo } from 'react';

import { AIChatAttachment } from '@atom/types/ai';

import { useChatContext } from './ChatContext';
import ChatUserMessageAttachments from './ChatUserMessageAttachments';

const ChatUserMessageAttachmentsContainer = memo(
  ({ messageId }: { messageId: string }) => {
    const {
      messagesData: { messages: rawMessages },
      attachmentsData: { attachments },
    } = useChatContext();

    const messageAttachments = useMemo(() => {
      const raw = rawMessages.find(msg => msg.id === messageId);

      const fromMetadata =
        ((raw as any)?.metadata?.attachments as AIChatAttachment[]) ?? [];

      if (fromMetadata.length > 0) {
        return fromMetadata;
      }

      return attachments[messageId] ?? [];
    }, [rawMessages, messageId, attachments]);

    return <ChatUserMessageAttachments attachments={messageAttachments} />;
  },
);

export default ChatUserMessageAttachmentsContainer;
